module.exports = __webpack_public_path__ + "static/jaculi-14623324594a879886a16ccab2019175.png";